import React from "react";
import { cn } from "./utils"; // 假設你有一個 cn 函數來合併 className

const Divider = ({
    children,
    className,
    dashed = false,
    variant = "solid",
    orientation = "center",
    orientationMargin,
    plain = true,
    style,
    type = "horizontal",
    spacing = "my-4", // 默認間距
}) => {
    const dividerClass = cn(
        "relative",
        {
            "border-b": type === "horizontal",
            "border-r": type === "vertical",
            "border-dashed": dashed || variant === "dashed",
            "border-dotted": variant === "dotted",
            "border-solid": variant === "solid",
            "text-center": orientation === "center",
            "text-left": orientation === "left",
            "text-right": orientation === "right",
            "text-muted-foreground": plain,
            [spacing]: spacing, // 加入外邊距
        },
        className
    );

    const customStyle = {
        ...(type === "vertical" && orientationMargin
            ? { marginTop: orientationMargin, marginBottom: orientationMargin }
            : {}),
        ...(type === "horizontal" && orientationMargin
            ? { marginLeft: orientationMargin, marginRight: orientationMargin }
            : {}),
        ...style,
    };

    return (
        <div className={dividerClass} style={customStyle}>
            {children && (
                <span
                    className={cn("absolute bg-background px-2", {
                        "left-0": orientation === "left",
                        "right-0": orientation === "right",
                        "left-1/2 transform -translate-x-1/2":
                            orientation === "center",
                    })}
                    style={{
                        top: '50%', // 垂直居中
                        transform: 'translate(-50%, -50%)', // 平移文字以達到正中央
                    }}
                >
                    {children}
                </span>
            )}
        </div>
    );
};

export default Divider;
